import React, { forwardRef, ReactElement } from 'react'
import clsx from 'clsx'
import styles from './style.module.scss'
import { Icon } from '@material-ui/core'
import ConditionalRender from '../../../utils/conditionalRender'

import XLoadingIndicator from '../XLoadingIndicator'
import { BUTTON_STYLE_TYPE } from '../../styles/constants'
import { ga4_buttonClicked } from 'utils/ga4'

export enum ButtonType {
    BUTTON = 'button',
    SUBMIT = 'submit',
    RESET = 'reset',
}

interface Props {
    children?: string | ReactElement
    loading?: boolean
    size?: string
    styleType?: string
    type?: ButtonType
    leftIcon?: string
    rightIcon?: string
    onClick?: () => void
    onSubmit?: () => void
    disabled?: boolean
    ga4_key?: string
}

const XButton = forwardRef<any, Props>((props: Props) => {
    const {
        onClick,
        onSubmit,
        children,
        size,
        styleType,
        type = ButtonType.BUTTON,
        leftIcon,
        rightIcon,
        disabled,
        loading = false,
    } = props

    return (
        <>
            <button
                onClick={() => {
                    onClick()
                    ga4_buttonClicked(props.ga4_key)
                }}
                onSubmit={onSubmit}
                className={clsx(styles.xbtn, styles[styleType], styles[size])}
                type={type}
                tabIndex={styleType === BUTTON_STYLE_TYPE.PASSWORD ? -1 : null}
                disabled={disabled}
            >
                <ConditionalRender if={loading}>
                    <XLoadingIndicator />
                </ConditionalRender>

                <ConditionalRender if={!loading}>
                    <ConditionalRender if={leftIcon}>
                        <Icon className={clsx(styles.icon)}>{leftIcon}</Icon>
                        <div className={clsx(styles.back_spacing)}></div>
                    </ConditionalRender>
                    {children}
                    <ConditionalRender if={rightIcon}>
                        <Icon className={clsx(styles.icon)}>{rightIcon}</Icon>
                    </ConditionalRender>
                </ConditionalRender>
            </button>
        </>
    )
})

XButton.displayName = 'XButton'
export default XButton
